import type { Reducer } from 'redux';

import type { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import type { Logging } from './types';

export type SessionAction = SessionConfigureAction;

const initialState: Logging = {
  logLevel: 'error',
};

const reducer: Reducer<Logging, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.logging;
    default:
      return state;
  }
};

export default reducer;
